import React from "react";

const DollarIcon = ({ color }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.4349 7.63536C10.7382 7.63536 10.1065 8.24025 10.1065 9.06419C10.1065 9.62532 10.2273 9.88198 10.3343 10.0184C10.4487 10.1644 10.6412 10.2941 11.0202 10.4287L15.5211 11.9923C16.0225 12.17 16.5662 12.4363 16.9678 12.9486C17.3771 13.4708 17.5521 14.1351 17.5521 14.9358C17.5521 16.6123 16.2414 18.0391 14.5493 18.0391H11.7475C9.87417 18.0391 8.43213 16.4645 8.43213 14.6009C8.43213 14.1386 8.80696 13.7637 9.26934 13.7637C9.73172 13.7637 10.1065 14.1386 10.1065 14.6009C10.1065 15.6174 10.8747 16.3647 11.7475 16.3647H14.5493C15.2461 16.3647 15.8777 15.7598 15.8777 14.9358C15.8777 14.3747 15.7569 14.118 15.65 13.9816C15.5355 13.8356 15.343 13.7059 14.9641 13.5714L10.4631 12.0077C9.96177 11.83 9.41807 11.5637 9.01649 11.0514C8.60714 10.5292 8.43213 9.86493 8.43213 9.06419C8.43213 7.38767 9.74284 5.96094 11.4349 5.96094H14.2368C16.1101 5.96094 17.5521 7.53554 17.5521 9.39908C17.5521 9.86146 17.1773 10.2363 16.7149 10.2363C16.2525 10.2363 15.8777 9.86146 15.8777 9.39908C15.8777 8.38261 15.1095 7.63536 14.2368 7.63536H11.4349Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M12.9842 4.46484C13.4466 4.46484 13.8214 4.83968 13.8214 5.30205V18.6974C13.8214 19.1598 13.4466 19.5346 12.9842 19.5346C12.5218 19.5346 12.147 19.1598 12.147 18.6974V5.30205C12.147 4.83968 12.5218 4.46484 12.9842 4.46484Z"
        fill={color}
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M4.22753 3.24316C3.20555 4.26515 2.65879 5.94304 2.65879 8.65116V15.3488C2.65879 18.057 3.20555 19.7349 4.22753 20.7568C5.24952 21.7788 6.92741 22.3256 9.63554 22.3256H16.3332C19.0413 22.3256 20.7192 21.7788 21.7412 20.7568C22.7632 19.7349 23.31 18.057 23.31 15.3488V8.65116C23.31 5.94304 22.7632 4.26515 21.7412 3.24316C20.7192 2.22117 19.0413 1.67442 16.3332 1.67442H9.63554C6.92741 1.67442 5.24952 2.22117 4.22753 3.24316ZM3.04354 2.05917C4.53318 0.569527 6.76227 0 9.63554 0H16.3332C19.2065 0 21.4356 0.569527 22.9252 2.05917C24.4149 3.54881 24.9844 5.77789 24.9844 8.65116V15.3488C24.9844 18.2221 24.4149 20.4512 22.9252 21.9408C21.4356 23.4305 19.2065 24 16.3332 24H9.63554C6.76227 24 4.53318 23.4305 3.04354 21.9408C1.5539 20.4512 0.984375 18.2221 0.984375 15.3488V8.65116C0.984375 5.77789 1.5539 3.54881 3.04354 2.05917Z"
        fill={color}
      />
    </svg>
  );
};

export default DollarIcon;
